module.exports = __webpack_public_path__ + "img/carousel-1-logo-1.2575a8cb.svg";